import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { SoundProvider } from "@/context/SoundContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

// Scroll to top on route change (unless navigating to an in-page anchor).
const ScrollToTop = () => {
  const { pathname, state } = useLocation();
  useEffect(() => {
    if (!state?.scrollTo) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, [pathname, state]);
  return null;
};

function App() {
  return (
    <div className="App relative bg-ivory text-charcoal">
      <BrowserRouter>
        <SoundProvider>
          <ReactLenis root options={{ lerp: 0.09, duration: 1.3, smoothWheel: true }}>
            <ScrollToTop />
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
            <Footer />
            <Toaster
              position="bottom-center"
              gap={12}
              toastOptions={{
                unstyled: true,
                classNames: {
                  toast:
                    "flex items-center gap-4 bg-forest text-ivory border border-gold/30 px-6 py-4 shadow-[0_20px_60px_rgba(47,79,70,0.35)] w-[min(92vw,420px)]",
                  title: "font-serif font-light text-lg leading-tight text-ivory",
                  description: "text-ivory/70 text-sm leading-snug mt-1",
                  icon: "text-gold text-xl",
                },
              }}
            />
          </ReactLenis>
        </SoundProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
